import { render, staticRenderFns } from "./ListAllReports.vue?vue&type=template&id=6a49ec08&lang=pug&"
import script from "./ListAllReports.vue?vue&type=script&lang=ts&"
export * from "./ListAllReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports